import React, { Fragment } from "react";
import { Grid } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import "./about.css";
import { Gauge } from "../visualisations/gauge";
import { Sunburst } from "../visualisations/sunburst";
import { BarChart } from "../visualisations/barchart";
import { useHistory } from "react-router-dom";
import { GenericGuideAccordion } from "./guide-accordions";
interface IProps {
  template: Template
}
export const GuidePage: React.FC<IProps> = (props: IProps) => {
  const history = useHistory();

  const data=props.template.envTemplate;
  const styles=props.template.envTemplateStyles;
  const [selectedTab, setSelectedTab] = React.useState<string>(
    Object.keys(data)[0]
  );
  return (
    <Fragment>
      <h2>Guide</h2>
      <p>
        The Performance Tracker has five main components as set by Southampton
        City Council; Sustainable Energy & Carbon Reduction, Delivering Clean
        Air & Quality of Life, Natural Environment, Resource, Waste & Water
        Management and Sustainable Travel.
        <br />
        <br />
        These guides provide a full breakdown and explanation on the scoring for
        all five themes, please note there are smaller document for each
        specific theme. The rating system document provides the scores, intent
        and requirements for each item. It is to be used alongside the Template
        with the results from the surveys feeding into an overall organisation
        score which can be used as a tool in prioritising sustainable action and
        investment across the Green City components.
        <br />
        <br />
        When asked about employees, this refers to staff working directly for
        the organisation of which you would be able to monitor their energy
        usage, car type, etc.. You should only count those that you, as an
        organisation, can influence, with the same logic applying for everything
        being considered, whereby you should only record data on people,
        buildings, etc. that you have responsibility for and a certain level of
        control over. Additionally all data will relate to the specific calendar
        year period, with yearly results presented to show progress over time.
        <br />
        <br />
        Please select one of the five themes to read the full theme guide,
        please note that each question within the template will have a link to
        the specific section.
      </p>
      <div className="content_container">
      {/* <AppBar position="static"> */}
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 5,
          width: "100%",
          marginLeft: 0,
        }}
      >
        {Object.keys(data).map((tabName: string) => {
          
          return (
            <Fragment key={tabName}>
              <Grid
                item
                xs={2}
                style={{
                  background: styles[tabName].themeBackground,
                  textAlign: "center",
                  color: "white",
                  // borderColor: selectedTab === tabName ? 'red' : 'white',
                  // borderBottomStyle: 'solid',
                  opacity: selectedTab === tabName ? 1 : 0.5,
                }}
                key={tabName}
                onClick={() => {
                  setSelectedTab(tabName);
                }}
              >
                <img
                  src={styles[tabName].img}
                  style={{ width: "100px" }}
                />
                <div style={{ fontSize: 14 }}>{tabName}</div>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 5,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
     
      </Grid>
      

      {/* </AppBar> */}
      {Object.keys(data).length === Object.keys(styles).length && Object.keys(data).length>0?
      <GenericGuideAccordion
        data={data[selectedTab]}
        envStyles={styles[selectedTab]}
        tabName={selectedTab}
      /> : null}
    </div>
    </Fragment>
  );
};
